import React from 'react';

const SeparatedDataCell = ({ value, infor }) => {
  const renderSeparatedData = () => {
    if (!value) {
      if (infor != "Email" && infor != "Họ tên học sinh" && infor != "Ghi chú" && infor != "Tư vấn viên" 
      && infor != "Khối lớp" && infor != "Điện thoại mẹ" && infor != "Họ tên mẹ"  && infor != "Điện thoại cha" && infor != "Họ tên cha") {
        return <p style={{ marginBottom: 0, color: 'red' }}>Vui lòng nhập {infor}</p>;
      }
      else {
        return <p style={{ marginBottom: 0 }}></p>;
      }
    }
    const separatedData = value.split('.#');
    return (
      <div style={{ marginBottom: 0 }}>
        {separatedData[0]}
        {separatedData[1] && (
          <>
            <hr />
            <span style={{ color: 'red' }}>{separatedData[1]}</span>
          </>
        )}
      </div>
    );

  };

  return renderSeparatedData();
};

export default SeparatedDataCell;